// extracted by mini-css-extract-plugin
export var active = "_ad-7";
export var container = "_ad-0";
export var evenWidth = "_ad-4";
export var large = "_ad-5";
export var outlet = "_ad-8";
export var slide = "_ad-2";
export var small = "_ad-6";
export var tab = "_ad-3";
export var tabs = "_ad-1";